import { useEffect, useRef } from 'react';

/**
 * Only triggers the effect on update (not on mount)
 * @param func
 * @param deps
 */
const useUpdateOnlyEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    didMount.current ? func() : didMount.current = true;
  }, deps);
};

export default useUpdateOnlyEffect;
